module.exports = __webpack_public_path__ + "static/media/s5.53f8752a.jpg";